import { extractMccs, extractMids, Parser } from 'SpendControl/parser'
import type { SpendControlTableProps } from 'SpendControl/SpendControlTable'

export const mid: SpendControlTableProps['parsers']['mid'] = (expression) => {
  const parser = new Parser(expression)

  const tree = parser.parse()

  return extractMids(tree, [])
}

export const mcc: SpendControlTableProps['parsers']['mcc'] = (expression) => {
  const parser = new Parser(expression)

  const tree = parser.parse()

  return extractMccs(tree, [])
}
